__turbopack_context__.v({
  "className": "ivyprestodisplay_2e3d5000-module__-yDVOq__className",
  "variable": "ivyprestodisplay_2e3d5000-module__-yDVOq__variable",
});
